import { SegmentedControl, type SegmentedControlProps } from '@mantine/core';
import { FONTS, TOKENS } from '../theme';

/**
 * A segmented control in the site's voice: mono uppercase labels on a quiet
 * track, the selected segment a white chip with a hairline. For period and
 * view switches in a page header.
 */
export function MonoSegmented(props: SegmentedControlProps) {
  return (
    <SegmentedControl
      size="xs"
      radius={8}
      {...props}
      styles={{
        root: {
          backgroundColor: TOKENS.surface2,
          border: `1px solid ${TOKENS.border}`,
          padding: 3,
        },
        indicator: {
          backgroundColor: TOKENS.surface,
          boxShadow: TOKENS.shadowChip,
          border: `1px solid ${TOKENS.border}`,
        },
        label: {
          fontFamily: FONTS.mono,
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          padding: '5px 12px',
        },
      }}
    />
  );
}
